import { axios } from '@/utils/request'

export default {
  getAll(input){
    return axios.get('/api/services/app/Order/GetAll',{params:input})
  },
  fahuo(input){
    return axios.post('/api/services/app/Order/Fahuo',input)
  }
}